export default {
  indexEndpoint: '/configuration',
  sendEmailEndpoint: '/configuration/send/email-example',
  storeEndpoint: '/configuration',
  editEndpoint: '/configuration/',
  updateEndpoint: '/configuration/',
  deleteEndpoint: '/configuration/',
}
